import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "img",
  class: "icon bi bi-moon fs-4",
  "aria-label": "The moon icon"
}
const _hoisted_2 = {
  key: 1,
  role: "img",
  class: "icon bi bi-sun fs-4",
  "aria-label": "The sun icon"
}

import { ThemeType, useGlobalStore } from "@/stores/GlobalStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleThemeButton',
  props: {
  theme: String as () => ThemeType,
  className: { type: String, default: "" },
},
  setup(__props) {

// import { BusType } from "@/globals/bus";
// import { inject, ref } from "vue";
// import { keyboardCheck } from "@/utils/utils";
// import { ThemeType } from "@/globals/state";
const props = __props;
// const bus = inject("$bus") as BusType;
const globalStore = useGlobalStore();
const toggleTheme = () => {
  globalStore.toggleTheme();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    tabindex: "0",
    class: _normalizeClass(["custom-hover position-relative fixed-width", __props.className]),
    onClick: toggleTheme,
    "aria-label": "Toggle to Light/Dark Theme",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space","enter"])),
    onKeyup: _withKeys(toggleTheme, ["space","enter"])
  }, [
    _createVNode(_TransitionGroup, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.theme === 'dark')
          ? (_openBlock(), _createElementBlock("i", _hoisted_1))
          : (_openBlock(), _createElementBlock("i", _hoisted_2))
      ]),
      _: 1
    })
  ], 34))
}
}

})